import { arrayOf, func, instanceOf } from 'prop-types'
import { Waypoint } from 'react-waypoint'

import Settings from '../../../../models/settings.js'
import Post from '../../../../models/Post.js'

export default function InfiniteScrollWaypoint({ load, posts, settings }) {
  if (!settings.isInfiniteScrollEnabled) {
    return null
  }

  if (posts.length >= settings.postCount) {
    return null
  }

  return (
    <Waypoint
      bottomOffset="-10px"
      onEnter={() => {
        load()
      }}
      scrollableAncestor={window}
    />
  )
}

InfiniteScrollWaypoint.propTypes = {
  load: func.isRequired,
  posts: arrayOf(instanceOf(Post)).isRequired,
  settings: instanceOf(Settings).isRequired,
}
